module.exports = __webpack_public_path__ + "static/media/baroInvert.957cab7f.jpg";